let previousScrollPosition = 0;
const minScrollPosition = 250;

window.addEventListener("load", setScrollClasses);

window.addEventListener("scroll", setScrollClasses);

let timeout: NodeJS.Timer;

function setScrollClasses() {
    if (timeout) {
        clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
        document.body.classList.toggle("scrolled", window.scrollY > minScrollPosition);

        document.body.classList.toggle(
            "down",
            window.scrollY > previousScrollPosition && window.scrollY > minScrollPosition
        );
        document.body.classList.toggle("up", window.scrollY < previousScrollPosition);

        if (!document.body.classList.contains("scrolled")) previousScrollPosition = window.scrollY;
    }, 60);
}
